import React from 'react'

import clsx from 'clsx'

import { useEventContext } from 'context/EventContext'

import classes from './ListingsFilterItem.module.scss'

/** @type {import("./types").default} */
const ListingsFilterItem = ({ filter: { label, value }, selected, onSelect }) => {
  const eventContext = useEventContext({
    engagementComponent: 'homepage_filters',
  })

  const onClick = () => {
    onSelect(value)
  }

  const isSelected = selected === value

  return (
    <button
      type="button"
      className={clsx('ListingsFilterItem', classes.root, isSelected && classes.selected)}
      data-testid="explore-filter"
      onClick={onClick}
      {...eventContext.addEvent({
        engagementDestination: 'filter',
        name: 'engagement_filter',
        engagementDetails: `filter-item_${value.replace(/_/g, '-')}`,
      })}
    >
      {label}
    </button>
  )
}

export default ListingsFilterItem
